import { ReactNode } from 'react';
import styles from '../expand.module.scss';

// The loading / error / empty message shared by every typed expand (AFE, DO, RC).
export const ExpandState = ({ children }: { children: ReactNode }) => (
  <div className={styles.state}>{children}</div>
);
